import { useField } from "./field";

const validKey = "valid";
export function useForm(init = {}) {
  const form = reactive({});

  for (const [key, value] of Object.entries(init)) {
    form[key] = useField(value);
  }

  form[validKey] = computed(() =>
    Object.keys(form)
      .filter((k) => k !== validKey)
      .every((k) => form[k].valid)
  );

  return form;
}

export function form2Body(form, type) {
  const body = { policyAccept: true, type };
  for (const [key, value] of Object.entries(form)) {
    if (key != validKey) body[key] = value.value;
  }
  return body;
}

export function clearForm(form) {
  for (const [key] of Object.entries(form)) {
    if (key != validKey) {
      form[key].value = "";
      form[key].touched = false;
    }
  }
}

export const formServerErrorText = "Ошибка отправки формы. Попробуйте позже.";
